const impactColor = (deltaR: number) => {
  if (deltaR > 0) {
    return 'green'
  }

  if (deltaR < 0) {
    return 'red'
  }

  return 'yellow'
}

export default impactColor
